import React, { PropTypes } from "react";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";

import { BILLING_PERIOD } from "../../../enums/ratePeriodTypes";
import { TextInput } from "../../../../../common/form";

const FixedTypeCoverage = (props) => {
  return (
    <div>
      <h3>
        <FormattedMessage id="clientCoverages.form.fixedRate" />
      </h3>
      {props.ratePeriodType === BILLING_PERIOD.value && (
        <p className="text-primary">
          <FormattedMessage id="clientCoverages.form.warnings.billingPeriodRate" />
        </p>
      )}
      <div className="type-table">
        <div className="row table-header">
          <div className="cell">
            <h5>
              {
                <FormattedMessage
                  id={`clientCoverages.form.invoicedClientRate.${props.ratePeriodType}`}
                />
              }
              <span className="required"> *</span>
            </h5>
          </div>

          <div className="cell">
            <h5>
              {
                <FormattedMessage
                  id={`clientCoverages.form.clientRate.${props.ratePeriodType}`}
                />
              }
              <span className="required"> *</span>
            </h5>
          </div>

          <div className="cell">
            <h5>
              {
                <FormattedMessage
                  id={`clientCoverages.form.providerRate.${props.ratePeriodType}`}
                />
              }
            </h5>
          </div>
        </div>

        <div className="row fixed-type">
          <div className="cell dollar">
            <Field
              id="invoicedClientRate"
              name="invoicedClientRate"
              component={TextInput}
              type="absNumber"
              readOnly={props.readOnly}
            />
          </div>

          <div className="cell dollar">
            <Field
              id="clientRate"
              name="clientRate"
              component={TextInput}
              type="absNumber"
              onBlur={props.onChangeClientRate.bind(null, "clientRate")}
              readOnly={props.readOnly}
            />
          </div>

          <div className="cell dollar">
            <Field
              id="providerRate"
              name="providerRate"
              component={TextInput}
              type="absNumber"
              readOnly="readonly"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

FixedTypeCoverage.propTypes = {
  onChangeClientRate: PropTypes.func,
  ratePeriodType: PropTypes.string,
  readOnly: PropTypes.bool,
};

export default FixedTypeCoverage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/priceCalculation/FixedTypeCoverage.js